import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString, MaxLength } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class PatchOrderRecipientDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Recipient full name' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderRecipientDto.prototype, "fullName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Recipient phone number' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderRecipientDto.prototype, "phoneNumber", void 0);
//# sourceMappingURL=PatchOrderRecipientDto.js.map